import axios from "axios";
import ApiBase from "./ApiBase";

class Application extends ApiBase
{
    async browseByGroup(groupId) {
        return await this.get("v1/application?groupId=" + groupId)
    }

    async read(id) {
        return await this.get("v1/application/" + id)
    }
}

export default Application
